const shippingCutoff = Date.parse('2026-07-19T10:00:00Z');
const noticeEnd = Date.parse('2026-08-02T22:00:00Z');

function updateVacationShippingNotices(root = document) {
  const now = Date.now();

  root.querySelectorAll('[data-vacation-shipping-notice]').forEach((notice) => {
    if (now >= noticeEnd) {
      notice.hidden = true;
      return;
    }

    const text = notice.querySelector('[data-vacation-shipping-notice-text]');
    if (!text) return;

    text.textContent = now >= shippingCutoff ? notice.dataset.afterText : notice.dataset.beforeText;
  });
}

updateVacationShippingNotices();

document.addEventListener('shopify:section:load', (event) => {
  updateVacationShippingNotices(event.target);
});
